<template>
  <div class="page">
    <div class="title">排行榜</div>
    <div class="wrap">
      <div class="ranking">
        <div
          class="ranking-title"
          @click="handleDetailShow('总馆排行榜', [1, 3, 4])"
        >
          <div class="circular">
            <img src="../assets/images/ranking.png" alt="总馆排行榜" />
          </div>
          <p>总馆排行榜</p>
        </div>
        <div
          class="ranking-title"
          @click="handleDetailShow('文科馆排行榜', [7])"
        >
          <div class="circular">
            <img src="../assets/images/ranking.png" alt="文科馆排行榜" />
          </div>
          <p>文科馆排行榜</p>
        </div>
        <div
          class="ranking-title"
          @click="handleDetailShow('理科馆排行榜', [8])"
        >
          <div class="circular">
            <img src="../assets/images/ranking.png" alt="理科馆排行榜" />
          </div>
          <p>理科馆排行榜</p>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <van-popup
      v-model="dialogDetail"
      position="bottom"
      class="dialog"
      :style="{ height: '100%' }"
    >
      <div class="package">
        <!-- 标题 -->
        <div class="dialog-title">{{ title }}</div>
        <!-- 内容 -->
        <div class="mask">
          <div class="dialog-warp" v-for="item in chartIdList" :key="item.id">
            <div class="warp-title">{{ admissionTitle[item.id] }}</div>
            <!-- 轮播部分 -->
            <div class="mask-rotation" v-if="item.list.length > 0">
              <!-- 前三固定学院 -->
              <div
                class="fixed"
                :style="{ height: classOption.singleHeight * 3 + 'px' }"
              >
                <div
                  v-for="(i, index) in item.list1"
                  :key="index"
                  class="college-number"
                  ref="roll"
                  :style="{ height: classOption.singleHeight + 'px' }"
                >
                  <div class="college">
                    {{ i.listName }}
                  </div>
                  <div class="number">
                    <div
                      class="cylinder"
                      :style="{
                        width: `${(i.peopleTotal / item.subscriptMax) * 100}%`,
                      }"
                    ></div>
                  </div>
                </div>
              </div>
              <!-- 学院轮播 -->
              <vue-seamless-scroll
                :style="{ height: classOption.singleHeight * 7 + 'px' }"
                :data="item.list2"
                class="rotation"
                :class-option="classOption"
                ref="seamlessScroll"
              >
                <div
                  v-for="(i, index) in item.list2"
                  :key="index"
                  class="college-number"
                  :style="{ height: classOption.singleHeight + 'px' }"
                >
                  <div class="college">
                    {{ i.listName }}
                  </div>
                  <div class="number">
                    <div
                      class="cylinder"
                      :style="{
                        width: `${(i.peopleTotal / item.subscriptMax) * 100}%`,
                      }"
                    ></div>
                  </div>
                </div>
              </vue-seamless-scroll>
              <!-- 人数下标 -->
              <div class="subscript">
                <div class="left"></div>
                <div class="right">
                  <span v-for="(i, index) in item.subscriptList" :key="index">{{
                    i
                  }}</span>
                </div>
              </div>
            </div>
            <div v-else class="empty">
              <van-empty description="暂无排行榜数据" />
            </div>
          </div>
        </div>
        <!-- 关闭按钮 -->
        <div class="close">
          <van-button color="#3770D3" block round @click="dialogDetail = false"
            >关 闭</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { rankingGet } from "@/api/ranking-chart";
import { STATUS_CODE_OK } from "@/config";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "RankingChart",
  data() {
    return {
      dialogDetail: false, //控制弹窗
      title: "", //弹窗的大标题
      admissionTitle: {
        1: "最近7天入馆院系排行榜(总榜)",
        3: "中文预约书籍排行榜",
        4: "外文预约书籍排行榜",
        7: "最近7天文科馆入馆院系排行榜",
        8: "最近7天理科馆入馆院系排行榜",
      }, //柱状轮播图标题
      chartIdList: [], //弹窗内的柱状轮播图数据
      classOption: {
        openTouch: false,
        singleHeight: 25,
        waitTime: 3000,
      }, //轮播速度
    };
  },
  methods: {
    // 点击事件调用排行榜接口
    async handleDetailShow(title, list) {
      const that = this;
      that.dialogDetail = true;
      that.$nextTick(() => {
        that.title = title;
        // map遍历id
        that.chartIdList = list.map((id) => {
          return {
            id: id, //柱状轮播图排行版id
            list: [], //弹窗内的柱状轮播图排行版数据
            list1: [], //排行榜人数前三最高的数据
            list2: [], //排行榜除人数前三所有的数据
            subscriptList: [], //总的下标
            subscriptMax: "", //下标最大值
          };
        });
        //forEach循环 通过不同id调用不同排行榜请求
        that.chartIdList.forEach(async (item) => {
          let { data } = await rankingGet({
            rankingListFlag: item.id,
          });
          if (data.code === STATUS_CODE_OK) {
            if (data.data.length > 0) {
              item.list = data.data.sort((a, b) => {
                return b.peopleTotal - a.peopleTotalz;
              });
              item.subscriptMax = item.list[0].peopleTotal;
              // 拿取下标
              for (let i = 0; i <= 4; i++) {
                item.subscriptList.push(
                  Math.ceil((item.list[0].peopleTotal / 4) * i)
                );
              }
              // 拿最大人数的三个
              item.list1 = item.list.slice(0, 3);
              // 拿其他的全部
              item.list2 = item.list.slice(3);
              that.$nextTick(() => {
                if (that.$refs.roll.length > 0) {
                  that.classOption.singleHeight = parseInt(
                    that.$refs.roll[0].offsetHeight
                  );
                  that.$nextTick(() => {
                    that.$refs.seamlessScroll.forEach((item) => {
                      item.reset();
                    });
                  });
                }
              });
            }
          }
        });
      });
    },
  },
  components: {
    vueSeamlessScroll,
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  height: 100%;
  .title {
    font-size: 22px;
    text-align: center;
    padding: 10px 0;
    color: #fff;
    background-color: #005097;
  }
  .wrap {
    background-color: #fff;
    padding: 20px 0;
    .ranking {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 16px;
      .circular {
        width: 50px;
        height: 50px;
        background-color: #005097;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        img {
          width: 30px;
          height: 30px;
        }
      }
      .ranking-title {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
  .dialog {
    .package {
      height: 100%;
      position: relative;
      padding-top: 51px;
      padding-bottom: 62px;
      background: #f5f5f6;
      .dialog-title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        width: 100%;
        height: 51px;
        color: #fff;
        background-color: #005097;
        position: absolute;
        top: 0;
        left: 0;
      }
      .mask {
        height: 100%;
        overflow-y: auto;
        .dialog-warp {
          background: #f5f5f6;
          margin-bottom: 15px;
          border: 1px solid #e2e2e2;
          box-shadow: 0 0 4px #ddd;
          .warp-title {
            font-size: 16px;
            text-align: left;
            padding: 6px 0;
            padding-left: 10px;
            color: #000;
            border-bottom: 1px solid #ddd;
          }
          .mask-rotation {
            background-color: #151f45;
            margin: 12px;
            padding: 10px;
            .fixed {
              height: 75px;
              .college-number {
                display: flex;
                align-items: center;
                height: 25px;
                .college {
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 14px;
                  flex: 0 0 155px;
                  margin-right: 10px;
                  color: #ffffff;
                }
                .number {
                  flex: 1;
                  .cylinder {
                    background: rgba(81, 117, 237, 1);
                    border-radius: 25px;
                    height: 12px;
                  }
                }
              }
            }
            .rotation {
              overflow: hidden;
              height: 175px;
              .college-number {
                display: flex;
                align-items: center;
                height: 25px;
                .college {
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 14px;
                  flex: 0 0 155px;
                  margin-right: 10px;
                  color: #ffffff;
                }
                .number {
                  flex: 1;
                  .cylinder {
                    background: #5175ed;
                    border-radius: 25px;
                    height: 12px;
                  }
                }
              }
            }
            .subscript {
              display: flex;
              align-items: center;
              margin-top: 10px;
              .left {
                flex: 0 0 155px;
                margin-right: 10px;
              }
              .right {
                color: #ffffff;
                flex: 1;
                height: 25px;
                font-size: 15px;
                display: flex;
                justify-content: space-between;
              }
            }
          }
          .empty {
            background: #fff;
          }
        }
      }
      .close {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px;
      }
    }
  }
}
</style>
